var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"disabled":!_vm.alerta.placaValido && !_vm.alerta.placaCompleta,"variant":!_vm.ativar ? 'warning' : ''},on:{"click":_vm.btnSalvarAlterar}},[_vm._v("Alterar")])}
var staticRenderFns = []

export { render, staticRenderFns }